export enum UserRole {
	User = 'USER', // user
	Viewer = 'VIEWER', // viewer
	Editor = 'EDITOR', // editor
	Writer = 'WRITER', // writer
	Admin = 'ADMIN' // admin
}

export type UserRoles = typeof UserRole;
